import { getCurrentCart as getCurrentEcomCart } from '@wix/ambassador-ecom-v1-cart/http';
import { BOOKINGS_APP_DEF_ID } from '@wix/bookings-adapter-ooi-wix-sdk';
import { query } from '@wix/ambassador-bookings-reader-v2-extended-booking/http';
export const getCurrentCart = async ({ httpClient, }) => {
    return (await httpClient.request(getCurrentEcomCart({}))).data;
};
const cartPopulator = async (cart, { httpClient }) => {
    var _a, _b, _c;
    const bookingIds = (_a = cart === null || cart === void 0 ? void 0 : cart.lineItems) === null || _a === void 0 ? void 0 : _a.filter((lineItem) => { var _a; return ((_a = lineItem.catalogReference) === null || _a === void 0 ? void 0 : _a.appId) === BOOKINGS_APP_DEF_ID; }).map((lineItem) => { var _a; return (_a = lineItem.catalogReference) === null || _a === void 0 ? void 0 : _a.catalogItemId; });
    if (!bookingIds || (bookingIds === null || bookingIds === void 0 ? void 0 : bookingIds.length) === 0) {
        return [];
    }
    try {
        const extendedBookings = ((_c = (_b = (await httpClient.request(query({
            query: {
                filter: {
                    id: { $in: bookingIds },
                },
            },
        })))) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.extendedBookings) || [];
        return extendedBookings;
    }
    catch (error) {
        throw new Error('An error occured trying to receive bookings from cart');
    }
};
export const getBookingsLineItemsOptions = async (config) => {
    const isEcom = await config.isBookingsOnEcomPromise;
    const { experiments } = config;
    const isPreventConflictsOnCartEnabled = experiments.enabled('specs.bookings.PreventConflictsOnCart');
    if (!isEcom) {
        return [];
    }
    const bookingsFromCurrentCart = await getBookingsFromCurrentCart(config);
    const options = bookingsFromCurrentCart.map((booking) => {
        var _a, _b, _c, _d, _e, _f;
        return (Object.assign(Object.assign({ scheduleId: (_b = (_a = booking.bookedEntity) === null || _a === void 0 ? void 0 : _a.schedule) === null || _b === void 0 ? void 0 : _b.scheduleId }, (isPreventConflictsOnCartEnabled
            ? { slot: (_c = booking.bookedEntity) === null || _c === void 0 ? void 0 : _c.slot, tags: (_d = booking.bookedEntity) === null || _d === void 0 ? void 0 : _d.tags }
            : { sessionId: (_f = (_e = booking.bookedEntity) === null || _e === void 0 ? void 0 : _e.slot) === null || _f === void 0 ? void 0 : _f.sessionId })), { numberOfParticipants: booking.numberOfParticipants, contactDetails: booking.contactDetails }));
    });
    return options;
};
export const getBookingsFromCurrentCart = async (config) => {
    const isEcom = await config.isBookingsOnEcomPromise;
    if (!isEcom) {
        return [];
    }
    try {
        const currentCartResponse = await getCurrentCart(config);
        const currentCart = currentCartResponse === null || currentCartResponse === void 0 ? void 0 : currentCartResponse.cart;
        return (await cartPopulator(currentCart, config)).map((extendedBooking) => extendedBooking.booking);
    }
    catch (e) {
        return [];
    }
};
//# sourceMappingURL=getBookingsFromCurrentCart.js.map